<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训计划列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="计划状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择计划状态">
            <el-option v-for="item in $store.state.planStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="审核状态">
          <el-select v-model="formInline.apply_status" clearable placeholder="请选择审核状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增实训计划</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训计划导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" label="实训计划名称" min-width="120">
        </custom-table-column>
        <!-- <custom-table-column fixed prop="training_room_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column> -->
        <!-- <custom-table-column fixed label="审核状态" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.apply_status=='apply'" style="color:var(--blue);">待审核</span>
            <span v-if="scope.row.apply_status=='pass'" style="color:var(--ligtGreen);">已通过</span>
            <span v-if="scope.row.apply_status=='refuse'" style="color:var(--red);">已拒绝</span>
          </template>
        </custom-table-column> -->
        <custom-table-column label="计划状态" width="150" prop="status"  label-class-name="planStatus" :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="160">
        </custom-table-column>
        <custom-table-column prop="class_plan_list" label="课程内容" min-width="260">
          <template slot-scope="scope">
           <p v-for="item in scope.row.class_plan_list" :key="item.id" >{{`${item.course_name},${item.week}周,${item.sector}节,${item.xq}`}}</p>
          </template>
        </custom-table-column>
        <custom-table-column prop="start_time" label="开始时间" width="180">
        </custom-table-column>
        <custom-table-column prop="end_time" label="结束时间" width="180">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="160">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="180">
        </custom-table-column>
        <custom-table-column prop="desc" label="备注" min-width="280">
        </custom-table-column>
        <!-- <custom-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport,mixinFormatter],
  data() {
    return {
      classRooms: [],
      institutes: [],
      formInline: {
        status: '',
        apply_status: '',
        training_room_name: '',
      },
      levell: [1, 2],
      organLabel: '',
      formInline1: {
        training_name: '',
        status: 'pass',
        structure_1: '',
        structure_2: '',
        course_name: '',
        term: '',
      },
      tableData1: [],
      total1: 0,
      detailDialogVisible: false,
      selectName: '',
      ruleForm: {
        name: '',
        term: '',
        start_time: '',
        end_time: '',
        structure_1: '',
        major: '',
        desc: '',
        class_plan_ids: '',
      },
      rules: {
        name: [{ required: true, message: '请输入实训计划名称', trigger: 'blur' }],
        term: [{ required: true, message: '请选择学年学期', trigger: 'change' }],
        major: [
          { required: true, message: '请选择院系+专业' },
        ],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      loading: false,
      users: [],
      action: '',
      downloadUrl: 'template/实训计划导入模版.xlsx',
      downloadName: '实训计划导入模版.xlsx',
      btnTitle: '导入实训计划数据',
      dynamicTags: [],
      multipleSelection: [],
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.action = `${this.baseUrlt}api/training_plan/import`;
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
    
  },
  methods: {
    handleTeacherChange(val) {
      this.ruleForm.teacher = this.$until.getLabelName(this.users, 'number', 'name', val);
      console.log(this.ruleForm);
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async applyStatus(plan_id, apply_status, str) {
      let params = { plan_id, apply_status };
      let res = await this.$api.update.applyPlanStatus(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `${str}成功!`,
        });
        this.handleQuery();
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
      this.tableData1 = [];
    },
    handleTremChange(e) {
      this.tableData1 = [];
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    // getOrganList() {
    //   this.tableData1 = [];
    //   this.beforeGetOrgan()
    // },
    async deleteMethod() {
      let params = { plan_id: this.delid };
      let res = await this.$api.delet.deletePlanV2(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (this.dynamicTags && this.dynamicTags.length) {
        params.class_plan_ids = this.dynamicTags
          .map((item) => {
            return item.id;
          })
          .join(',');
      }
      let res = await this.$api.creat.creatTrainPlanV2(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
        this.dynamicTags = [];
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      if (this.dynamicTags && this.dynamicTags.length) {
        params.class_plan_ids = this.dynamicTags
          .map((item) => {
            return item.id;
          })
          .join(',');
      }
      let res = await this.$api.update.updateClassPlanV2(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getAdminPlanesV2(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
.el-tag {
  margin-right: 10px;
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
